export const FallbackComponent = () => {
  return <div>An error has occurred</div>;
};
